import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  CLEAR_VISIT_DATA,
  DELETE_VISIT_REMARK,
  DELETE_VISIT_REMARK_ERROR,
  DELETE_VISIT_REMARK_SUCCESS,
  GET_REMARKS,
  GET_REMARKS_ERROR,
  GET_REMARKS_SUCCESS,
  GET_VISIT_INFO,
  GET_VISIT_INFO_SUCCESS,
  GET_VISITS,
  GET_VISITS_ERROR,
  GET_VISITS_SUCCESS,
  SET_DELETE_REMARK_ID,
  SET_EDIT_REMARK_ID,
  SET_VISIT_ERROR,
  UPDATE_UPCOMING_VISIT_REMARK,
  UPDATE_UPCOMING_VISIT_REMARK_SUCCESS,
  UPDATE_UPCOMING_VISIT_REMARK_ERROR,
  SET_CANCELLED_VISIT_ID,
  CLEAR_CANCELLED_VISIT_ID,
} from './VisitsConstants'
import { CREATE_PATIENT_VISIT_REMARKS_SUCCESS } from '../patient-side-panel/PatientSidePanelConstants'
import { GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS } from '../file-pop-up/FilePopUpConstants'
import { GET_PATIENTS_CHART_SUCCESS } from '../charts/ChartsConstants'

const initialState = {
  loading: false,
  error: '',
  visitData: {},
  visits: null,
  remarks: {},
  deleteRemarkId: null,
  editRemarkId: null,
  cancelledVisitId: null,
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export default function visitsPageReducer(state = initialState, action) {
  switch (action.type) {
    case GET_VISITS:
    case GET_VISIT_INFO:
    case GET_REMARKS:
    case DELETE_VISIT_REMARK:
    case UPDATE_UPCOMING_VISIT_REMARK:
      return {
        ...state,
        loading: true,
      }
    case SET_VISIT_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case GET_VISIT_INFO_SUCCESS:
      return {
        ...state,
        visitData: action.payload,
        loading: false,
      }
    case CLEAR_VISIT_DATA:
      return {
        ...state,
        visitData: null,
      }
    case GET_VISITS_SUCCESS: {
      const visitsList = action.payload?.Items || []
      const totalCount = action.payload?.TotalCount || 0

      return {
        ...state,
        visits: { visitsList, totalCount },
        loading: false,
      }
    }

    case SET_DELETE_REMARK_ID: {
      return {
        ...state,
        deleteRemarkId: action.payload,
      }
    }

    case SET_EDIT_REMARK_ID: {
      return {
        ...state,
        editRemarkId: action.payload,
      }
    }
    case UPDATE_UPCOMING_VISIT_REMARK_SUCCESS: {
      const { visitId, remarkId } = action.extraData

      return {
        ...state,
        loading: false,
        remarks: {
          ...state.remarks,
          [visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.remarks[visitId],
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            remarksList: state.remarks[visitId].remarksList.map((remark) =>
              remark.RemarkId === remarkId ? { ...action.payload.data } : remark,
            ),
          },
        },
      }
    }

    case DELETE_VISIT_REMARK_SUCCESS:
      const { visitId: visitIdValue, remarkId } = action.extraData
      return {
        ...state,
        loading: false,
        deleteRemarkId: null,
        remarks: {
          ...state.remarks,
          [visitIdValue]: {
            visitId: visitIdValue,
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            remarksList: state.remarks[visitIdValue].remarksList.filter(({ RemarkId }) => RemarkId !== remarkId),
          },
        },
      }

    case GET_PATIENTS_CHART_SUCCESS:
    case GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const updatedVisitsList = JSON.parse(JSON.stringify(state.visits?.visitsList || []))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedVisitsList.forEach((visit, index) => {
        if (visit.Patient.PatientId === action.extraData.patientId) {
          visit.Patient.DrugScreen = action.payload.DrugScreen
          visit.Patient.IdentityVerification = action.payload.IdentityVerification
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedVisitsList[index] = visit
        }
      })
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visits: { ...state.visits, visitsList: updatedVisitsList },
      }
    case GET_REMARKS_SUCCESS:
      const { visitId } = action.extraData
      return {
        ...state,
        remarks: {
          ...state.remarks,
          [visitId]: {
            visitId,
            remarksList: action.payload,
          },
        },
        loading: false,
      }
    case CREATE_PATIENT_VISIT_REMARKS_SUCCESS:
      return {
        ...state,
        remarks: {
          ...state.remarks,
          [action.extraData.visitId]: {
            visitId: action.extraData.visitId,
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            remarksList: [...(state?.remarks?.[action.extraData.visitId]?.remarksList || []), action.payload],
          },
        },
      }
    case GET_REMARKS_ERROR:
    case GET_VISITS_ERROR:
    case UPDATE_UPCOMING_VISIT_REMARK_ERROR:
    case DELETE_VISIT_REMARK_ERROR: {
      if (action.payload.UserFriendlyErrorCode) {
        return {
          ...state,
          error: getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, '', action.payload.extra),
          loading: false,
        }
      }
      if (action.payload.ErrorCode === 'PeriodNotValid') {
        return {
          ...state,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'period'),
          loading: false,
        }
      }
      if (action.payload.ErrorCode === 'VisitNotFound') {
        return {
          ...state,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'The visit'),
          loading: false,
        }
      }
      if (action.payload.ErrorCode === 'InternalServerError') {
        return {
          ...state,
          error: getUserFriendlyErrorMessage(errorCodes.DEFAULT),
          loading: false,
        }
      }
      return {
        ...state,
        error: '',
        loading: false,
      }
    }
    case SET_CANCELLED_VISIT_ID:
      return {
        ...state,
        cancelledVisitId: action.payload,
      }

    case CLEAR_CANCELLED_VISIT_ID:
      return {
        ...state,
        cancelledVisitId: null,
      }

    default:
      return state
  }
}
